<div>
      <invite-list  [canAll]=true></invite-list>
</div>
  